import { render, staticRenderFns } from "./ReleaseNotesModal.vue?vue&type=template&id=0c31d39b&scoped=true"
import script from "./ReleaseNotesModal.vue?vue&type=script&lang=js"
export * from "./ReleaseNotesModal.vue?vue&type=script&lang=js"
import style0 from "./ReleaseNotesModal.vue?vue&type=style&index=0&id=0c31d39b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c31d39b",
  null
  
)

export default component.exports